import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=77c98098&scoped=true"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=77c98098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c98098",
  null
  
)

export default component.exports